import { createSlice } from '@reduxjs/toolkit'

interface AppSliceInitialState {
  mapDataDrawer: {
    open: boolean
  }
}

const initialState: AppSliceInitialState = {
  mapDataDrawer: {
    open: false,
  }
}


export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setMapDataDrawerOpen: (state, action) => {
      state.mapDataDrawer.open = action.payload;
    }
  },
  extraReducers: (builder) => {},
})

export const AppActions = {
  ...appSlice.actions,
}

export const AppReducer = appSlice.reducer
